import type { CartItem } from '../types';
import { readJson, writeJson } from '../services/mock/storage';

const CART_STORAGE_KEY = 'hsl_cart';

export function loadStoredCart(): CartItem[] {
  return readJson<CartItem[]>(CART_STORAGE_KEY, []);
}

export function saveStoredCart(items: CartItem[]) {
  writeJson(CART_STORAGE_KEY, items);
}

export function clearStoredCart() {
  localStorage.removeItem(CART_STORAGE_KEY);
}
